import { Outlet, createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/_app/library/workflows/$workcellId/$workflowId',
)({
  component: Outlet,
})
